import React from 'react';
import _ from 'lodash';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Checkbox from "material-ui/Checkbox";
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import NumberField from '../../../Base/NumberField';

const modes = ['Laden', 'Ballast', 'Eco Laden', 'Eco Ballast', 'Idle', 'Working'];
const typesOfIfo = ["VLS FO", "ULS FO", "HFO 180", "HFO 380"];
const typesOfMdo = ["MGO", "LS MGO"];


class SpeedConsumptionV2 extends React.Component {
    constructor(props) {
        super(props);
        
        this.add = this.add.bind(this);
        this.remove = this.remove.bind(this);
        this.removeSpeed = this.removeSpeed.bind(this);
    }

    add() {
        const speedConsumptionV2 = _.cloneDeep(this.props.speedConsumptionV2);

        speedConsumptionV2.push({
            mode: '',
            speed: '',
            ifo: {
                typeIfo: 'HFO 180',
                cons: '',
            },
            mdo: {
                typeMdo: 'MGO',
                cons: '',
            },
        });

        this.props.changeField({
            field: 'speedConsumptionV2',
            value: speedConsumptionV2,
        });
    }

    remove(index) {
        const speedConsumptionV2 = _.cloneDeep(this.props.speedConsumptionV2);

        speedConsumptionV2.splice(index, 1);
        this.props.changeField({
            field: 'speedConsumptionV2',
            value: speedConsumptionV2,
        });
    }

    removeSpeed(index) {
        this.props.changeField({
            field: `speedConsumptionV2[${index}].speed`,
            value: '',
        });
    }

    componentDidMount() {
        this.props.changeField({
            field: 'speedConsumptionV2',
            value: this.props.speedConsumptionV2,
        });
    }

    render() {
        const { getError, changeField, confirmed, speedConsumptionV2, modifiedFields, underStyle } = this.props;

        return (
            <React.Fragment>
                {
                    speedConsumptionV2.map((item, index) => {
                        return (
                            <div className='row' key={index}>
                                <div className='col-xs-2'>
                                    <SelectField
                                        name={`speedConsumptionV2[${index}].mode`}
                                        disabled={confirmed}
                                        value={speedConsumptionV2[index].mode || ''}
                                        errorText={getError(`speedConsumptionV2[${index}].mode`)}
                                        onChange={(e, i, value) => {
                                            changeField({
                                                field: `speedConsumptionV2[${index}].mode`,
                                                value,
                                            });

                                            // remove data from speed input if 'idle' or 'working' are selected
                                            if(modes.indexOf(value) === 5 
                                                || modes.indexOf(value) === 6) {
                                                    this.removeSpeed(index);
                                            } 
                                        }}
                                        floatingLabelText='Mode (sea, port)'
                                        fullWidth

                                        underlineStyle={modifiedFields && modifiedFields.includes(`speedConsumptionV2[${index}].mode`) ? underStyle : null}
                                    >
                                        {
                                            modes.map((mode, modeIndex) => {
                                                return (
                                                    <MenuItem 
                                                        key={modeIndex}
                                                        value={mode}
                                                        primaryText={mode}
                                                    />
                                                );
                                            })
                                        }
                                    </SelectField>
                                </div>
                                <div className='col-xs-1'>
                                    <NumberField
                                        name={`speedConsumptionV2[${index}].speed`}
                                        floatingLabelText='Speed, kn'
                                        value={speedConsumptionV2[index].speed || ''}
                                        floatNumber
                                        disabled={
                                            (modes.indexOf(speedConsumptionV2[index].mode) === 4 
                                                || modes.indexOf(speedConsumptionV2[index].mode) === 5) ?
                                                !confirmed
                                                :
                                                confirmed
                                        }
                                        errorText={getError(`speedConsumptionV2[${index}].speed`)}
                                        onChange={(e, value) => {
                                            changeField({
                                                field: `speedConsumptionV2[${index}].speed`,
                                                value,
                                            });
                                        }}
                                        fullWidth

                                        underlineStyle={modifiedFields && modifiedFields.includes(`speedConsumptionV2[${index}].speed`) ? underStyle : null}
                                    />
                                </div>
                                <div className='col-xs-2'>
                                    <SelectField 
                                        name={`speedConsumptionV2[${index}][ifo].typeIfo`}
                                        disabled={confirmed}
                                        value={speedConsumptionV2[index].ifo.typeIfo || ''}
                                        errorText={getError(`speedConsumptionV2[${index}][ifo].typeIfo`)}
                                        onChange={(e, i, value) => {
                                            changeField({
                                                field: `speedConsumptionV2[${index}][ifo].typeIfo`,
                                                value,
                                            });
                                        }}
                                        floatingLabelText='IFO'
                                        fullWidth

                                        underlineStyle={modifiedFields && modifiedFields.includes(`speedConsumptionV2[${index}][ifo].typeIfo`) ? underStyle : null}
                                    >
                                        {
                                            typesOfIfo.map((type, typeIndex) => {
                                                return (
                                                    <MenuItem 
                                                        key={typeIndex}
                                                        value={type}
                                                        primaryText={type}
                                                    />
                                                );
                                            })
                                        }
                                    </SelectField>
                                </div>
                                <div className='col-xs-1'>
                                    <NumberField
                                        name={`speedConsumptionV2[${index}][ifo].cons`}
                                        disabled={confirmed}
                                        value={speedConsumptionV2[index].ifo.cons || ''}
                                        errorText={getError(`speedConsumptionV2[${index}][ifo].cons`)}
                                        floatNumber
                                        onChange={(e, value) => {
                                            changeField({
                                                field: `speedConsumptionV2[${index}][ifo].cons`,
                                                value,
                                            });
                                        }}
                                        floatingLabelText='Cons'
                                        fullWidth

                                        underlineStyle={modifiedFields && modifiedFields.includes(`speedConsumptionV2[${index}][ifo].cons`) ? underStyle : null}
                                    />
                                </div>
                                <div className='col-xs-1'>
                                    <SelectField 
                                        name={`speedConsumptionV2[${index}][mdo].typeMdo`}
                                        disabled={confirmed}
                                        value={
                                            speedConsumptionV2[index].mdo ?
                                            speedConsumptionV2[index].mdo.typeMdo || '' :
                                            ''
                                        }
                                        errorText={getError(`speedConsumptionV2[${index}][mdo].typeMdo`)}
                                        onChange={(e, i, value) => {
                                            changeField({
                                                field: `speedConsumptionV2[${index}][mdo].typeMdo`,
                                                value,
                                            });
                                        }}
                                        floatingLabelText='MDO'
                                        fullWidth

                                        underlineStyle={modifiedFields && modifiedFields.includes(`speedConsumptionV2[${index}][mdo].typeMdo`) ? underStyle : null}
                                    >
                                        {
                                            typesOfMdo.map((type, typeIndex) => {
                                                return (
                                                    <MenuItem 
                                                        key={typeIndex}
                                                        value={type}
                                                        primaryText={type}
                                                    />
                                                );
                                            })
                                        }
                                    </SelectField>
                                </div>
                                <div className='col-xs-1'>
                                    <NumberField
                                        name={`speedConsumptionV2[${index}][mdo].cons`}
                                        disabled={confirmed}
                                        value={
                                            speedConsumptionV2[index].mdo ? 
                                                speedConsumptionV2[index].mdo.cons || '' :
                                                ''
                                        }
                                        errorText={getError(`speedConsumptionV2[${index}][mdo].cons`)}
                                        floatNumber
                                        onChange={(e, value) => {
                                            changeField({
                                                field: `speedConsumptionV2[${index}][mdo].cons`,
                                                value,
                                            });
                                        }}
                                        floatingLabelText='Cons'
                                        fullWidth

                                        underlineStyle={modifiedFields && modifiedFields.includes(`speedConsumptionV2[${index}][mdo].cons`) ? underStyle : null}
                                    />
                                </div>
                                <div className='col-xs-1'>
                                    <NumberField
                                        name={`speedConsumptionV2[${index}].lngCons`}
                                        disabled={confirmed}
                                        value={speedConsumptionV2[index].lngCons || ''}
                                        errorText={getError(`speedConsumptionV2[${index}].lngCons`)}
                                        floatNumber
                                        onChange={(e, value) => {
                                            changeField({
                                                field: `speedConsumptionV2[${index}].lngCons`,
                                                value,
                                            });
                                        }}
                                        floatingLabelText='LNG'
                                        fullWidth

                                        underlineStyle={modifiedFields && modifiedFields.includes(`speedConsumptionV2[${index}].lngCons`) ? underStyle : null}
                                    />
                                </div>
                                <div className='col-xs-2'>
                                    <Checkbox
                                        style={{ margin: '35px 0 0' }}
                                        label='Scrubber'
                                        checked={speedConsumptionV2[index].scrubber}
                                        onCheck={(e, checked) => {
                                            changeField({
                                                field: `speedConsumptionV2[${index}].scrubber`,
                                                value: checked,
                                            });
                                        }}
                                        iconStyle={{ marginRight: '8px' }}
                                    />
                                </div>
                                <div className='col-xs-1'>
                                    {
                                        !index ? 
                                            <IconButton style={{ margin: '25px 0 0 0' }}>
                                                <ContentAddIcon
                                                    onClick={() => {
                                                        this.add();
                                                    }} 
                                                    color='green'
                                                />
                                            </IconButton>
                                            :
                                            <IconButton style={{ margin: '25px 0 0 0' }}>
                                                <ContentRemoveIcon 
                                                    onClick={() => {
                                                        this.remove(index);
                                                    }}
                                                    color='red'
                                                />
                                            </IconButton>
                                    }
                                </div>
                            </div>
                        );       
                    })
                }
            </React.Fragment>
        );
    }
}

export default SpeedConsumptionV2;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/SpeedConsumptionV2.jsx